import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StepNavButtons from '../Sections/StepNavButtons';
import SelectedDate from '../Sections/Schedule/SelectedDate';
import SectionHeader from '../Basic/SectionHeader';
import { selectProjectModel } from '../../selectors/ProjectSpecifics';
import { selectedAddress } from '../../selectors/ServiceAddress';
import C from '../../lib/calendarHelper';
import util from '../../lib/util';
import * as consts from '../../constants';
import { nextStepClicked } from '../../actions';


class Schedule extends React.Component {
  constructor() {
    super();
    this.state = { nextStepSuccess: false, isSavePrjectCalled: false };
    C.clear(true);

  }
  componentWillMount() {
    const p = this.props;
    if (p.isRenderSchedule) {
      setTimeout(() => {
        const s2 = p.schedule;
        C.parseSchedule(s2.appointments);
        C.init(p);
        p.setRenderSchedule(false);
      }, 500);
    }
  }
  componentWillReceiveProps(p) {
    if (p.projectModel.ScheduleUpdated && !this.state.nextStepSuccess) {
      let nextStep = p.isLoggedIn ? 4 : 5;
      if (p.pageName == consts.NEW_GAS_LINE_NAME)
        nextStep++;//new gas line has one more step other than other products
      console.log(nextStep);
      p.onNextStepClicked(nextStep);
      this.setState({ nextStepSuccess: true });
      p.clearScheduleUpdated();
    }

    if (p.project && p.project.isSuccess && !this.state.isSavePrjectCalled && p.project.isRouteToDashboard) {
      util.routeToDashbord(p);
      this.setState({ isSavePrjectCalled: true });
    }

    if (!this.props.isCustomerSpecifiedDate && p.isCustomerSpecifiedDate) C.unselectEvent();

    const s1 = this.props.schedule;
    const s2 = p.schedule;
    if (!s2 || s1 === s2) return;

    if (s2.appointments && (s1 && s1.appointments) !== s2.appointments) {
      C.parseSchedule(s2.appointments);
    }
  }

  componentDidUpdate(old) {
    const p = this.props;
    let n = p.isLoggedIn ? 3 : 4;
    if (p.pageName == consts.NEW_GAS_LINE_NAME)
      n++;//new gas line has one more step other than other products

    if (old.activeIndex === n && p.activeIndex === n && p.project && p.project.isSuccess && !p.project.skipSchedule) {
      C.init(p);
    }
  }

  onSaveClick = () => {
    this.setState({ isSavePrjectCalled: false });
    const p = this.props;
    let model = p.projectModel;
    model.stepName = "dashboard";
    p.saveProject(model);
  };

  onNextClick = () => {
    this.setState({ nextStepSuccess: false });
    const p = this.props;
    const validators = [['noDateSelected', () => this.canNext(), '#' + window.osa.lookup.schedule.noDateSelected]];
    if (util.validate(validators, p, p.formError)) {
      if (p.isCustomerSpecifiedDate) {
        util.trackGoogleAnalytics(p.pageName, 'Project Offramped', 'Project Offramped at Schedule');
      } else {
        const schedule = p.schedule;
        const serviceOrder = p.projectModel.CafeData.ServiceOrders[0];
        if (serviceOrder) {
          const slot = schedule.appointments.find(appt => Date(appt.slotDate) == Date(schedule.scheduleStartDate));
          serviceOrder.slotId = slot.slotId;
        }
      }
      p.updateSchedule(p.projectModel);
    }
  };

  onBackClick = () => {
    this.setState({ nextStepSuccess: false });
    C.clear();
    const p = this.props;
    p.resetProjectSpecifics();
    p.onBackClick();
  };

  canNext = () => {
    const p = this.props;
    return p.isCustomerSpecifiedDate || (p.schedule && p.schedule.dateSelected);
  };

  render() {
    const p = this.props;
    const sl = window.osa.lookup.schedule || {};
    return (
      <div>
        <SectionHeader title={sl.title} />
        <div id="calendarHeader">
          <p>{sl.t31}</p>
          <p><span dangerouslySetInnerHTML={{ __html: sl.t32 }} /></p>
          <p>{sl.t33}</p>
          <p>{sl.t33a}</p>
        </div>
        <div id="calendar" />
        <SelectedDate dateSelected={!p.isCustomerSpecifiedDate && p.schedule && p.schedule.dateSelected} error={p.error} lookup={sl} />
        <StepNavButtons text="Next step" onNextClick={this.onNextClick} isShowSave={p.isLoggedIn} onSaveClick={this.onSaveClick} onBackClick={this.onBackClick} onCancelClick={p.onCancelClick} />
      </div>
    );
  }
}

Schedule.propTypes = {
  id: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    updateSchedule: (model) => dispatch({ type: 'UPDATE_SCHEDULE', model }),
    callClick: (model) => dispatch({ type: 'CALL_SCHEDULING', model }),
    dateSelected: m => dispatch({ type: 'DATE_SELECTED', m }),
    dateUnselected: m => dispatch({ type: 'DATE_UNSELECTED', m }),
    resetProjectSpecifics: () => dispatch({ type: 'PROJECT_RESET_SUCCESS' }),
    saveProject: (model) => dispatch({ type: 'SAVE_PROJECT', model }),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    clearScheduleUpdated: () => dispatch({ type: 'CLEAR_SCHEDULE_UPDATED' }),
    setRenderSchedule: (value) => dispatch({ type: 'SET_IS_RENDER_SCHEDULE', value })
  };
}

function mapStateToProps(state) {
  return {
    parcel: state.gas.parcel,
    project: state.gas.project,
    projectModel: selectProjectModel(state),
    address: selectedAddress(state),
    schedule: state.gas.schedule,
    isCustomerSpecifiedDate: state.form.isCustomerSpecifiedDate && state.form.isCustomerSpecifiedDate == 1,
    moveoutDate: state.gas.sapPremise && state.gas.sapPremise.moveoutDate,
    error: state.form && state.form.errors && state.form.errors.noDateSelected,
    pageName: state.gas.pageName,
    isRenderSchedule: state.gas.isRenderSchedule
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
